<template>
    <tr>
        <td
            v-for="(header, index) of headers"
            :key="index"
            :style="{ padding: `${rowPaddingPx}px` }"
        >
            <v-row
                no-gutters
                v-if="index === 0 && !hideName"
                @click="onNameClicked(props.item)"
                style="cursor: pointer"
            >
                <v-col cols="12" class="font-weight-medium pl-1">
                    {{ props.item.name }}
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-else
                class="rounded d-flex justify-center"
                :style="{
                    overflow: 'hidden',
                    cursor: 'pointer',
                    width: `${rowItemWidth}px`,
                    margin: 'auto',
                }"
            >
                <v-col :cols="nCols" class="ma-0" v-if="taxesSelectedContain('TVA')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'TVA', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'TVA', header.value)"
                        v-tooltip:bottom="getDeclarationInfos(props.item, 'TVA', header.value)"
                    >
                        <span
                            data-cy="taxesRow-TVA"
                            :class="
                                getColor(props.item, 'TVA', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >T</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>
                            {{  }}
                        </span>
                    </v-tooltip> -->
                </v-col>
                <v-col :cols="nCols" class="ma-0" v-if="taxesSelectedContain('IS')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'IS', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'IS', header.value)"
                        v-tooltip:bottom="getDeclarationInfos(props.item, 'IS', header.value)"
                    >
                        <span
                            data-cy="taxesRow-IS"
                            :class="
                                getColor(props.item, 'IS', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >I</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>
                            {{ getDeclarationInfos(props.item, "IS", header.value) }}
                        </span>
                    </v-tooltip> -->
                </v-col>
                <v-col :cols="nCols" class="ma-0" v-if="taxesSelectedContain('CVAE')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'CVAE', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'CVAE', header.value)"
                        v-bind="props"
                        v-tooltip:bottom="getDeclarationInfos(props.item, 'CVAE', header.value)"
                    >
                        <span
                            data-cy="taxesRow-CVAE"
                            :class="
                                getColor(props.item, 'CVAE', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >C</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>
                            {{ getDeclarationInfos(props.item, "CVAE", header.value) }}
                        </span>
                    </v-tooltip> -->
                </v-col>
            </v-row>
        </td>

        <oss-dialog
            v-show="false"
            v-model="actionDialog"
            :title="'Que voulez-vous faire ?'"
            max-width="800px"
        >
            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="onDialogRedirectClicked"
                            data-cy="AccountingClientMonitoring-redirection"
                            size="x-large"
                            >Aller sur la page</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary rounded block @click="onDialogIgnoreClicked" size="x-large"
                            >Ignorer</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
    </tr>
</template>

<script lang="ts">
import colors from "vuetify/lib/util/colors";
import moment from "moment-timezone";
import { setCurrentCompany } from "@/services/userServices";
import AccountingClientMonitoringServices from "@/services/accountingClientMonitoringServices";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

@Component({
    emits: ["name-clicked", "avatar-clicked", "dialog-ignore-clicked", "dialog-redirect-clicked"],
})
export class AccountingClientMonitoringTaxesRow extends Vue {
    @Prop({ default: () => [] }) headers: Array<any>;
    @Prop({ default: () => ({}) }) props: { [key: string]: any };
    @Prop({ default: null }) itemValue: any;
    @Prop({ default: null }) taxesMonitoringItem: string | { [key: string]: any };
    @Prop({ default: false }) showFECInfo: boolean;
    @Prop({ default: false }) hideName: boolean;
    @Prop({ default: () => [] }) taxesSelected: [];
    @Prop({ default: false }) useTriangleLayout: boolean;
    @Prop({ default: 0 }) rowPaddingPx: number;
    @Prop({ default: "mixed" }) taxType: "taxesDeposits" | "taxesBalances" | "mixed";

    actionDialog = false;
    actionDate = null;
    actionType = null;

    taxesTypesDict = [
        { key: "Acomptes", value: "taxesDeposits" },
        { key: "Soldes", value: "taxesBalances" },
    ];

    taxesTypes = ["taxesDeposits", "taxesBalances"];

    taxesDeposits = ["TVA", "IS", "CVAE"];
    taxesBalances = ["IS", "CVAE"];

    get taxes() {
        switch (this.taxType) {
            case "taxesDeposits":
                return this.taxesDeposits;
            case "taxesBalances":
                return this.taxesBalances;
            default:
                return this.taxesDeposits; // taxesDeposits values contain taxesBalances values
        }
    }

    get isTaxesDeposits() {
        return this.taxType === "taxesDeposits";
    }

    get isTaxesBalances() {
        return this.taxType === "taxesBalances";
    }

    get isMixed() {
        return this.taxType === "mixed";
    }

    /**
     * Check if in the taxesMonitoringItem item object, the corresponding tax and date is of type 'taxesBalances'
     * @param tax
     * @param date
     */
    isInTaxesBalances(tax, date) {
        let theoreticalClosingDate = date;
        if (tax === "CVAE") {
            theoreticalClosingDate = `${parseFloat(date.slice(0, 4)) - 1}-12`;
        } else if (tax === "IS") {
            theoreticalClosingDate =
                date.slice(-2) === "05"
                    ? moment(new Date(date)).subtract(5, "months").format("YYYY-MM")
                    : moment(new Date(date)).subtract(4, "months").format("YYYY-MM");
        }

        if (
            this.taxesMonitoringItem &&
            this.taxesMonitoringItem[tax] &&
            this.taxesMonitoringItem[tax][theoreticalClosingDate]
        ) {
            const cerfaNumber =
                this.taxesMonitoringItem[tax][theoreticalClosingDate].cerfaNumber || "";
            return Boolean(this.taxesBalances.includes(tax) && this.taxesBalancesDico[cerfaNumber]);
        }
        return false;
    }

    /***
     * Compute width of the containing avatars
     */
    get rowItemWidth() {
        const nSelected = this.taxesSelected.length || 1;
        const avatarWidthPx = 25;
        if (nSelected < 3) {
            return nSelected * avatarWidthPx;
        }
        if (this.useTriangleLayout) {
            return (nSelected - 1) * avatarWidthPx;
        }
        return nSelected * avatarWidthPx;
    }

    /**
     * Compute number of colums per avatar
     */
    get nCols() {
        const nSelected = this.taxesSelected.length || 1;
        if (nSelected === 1) {
            return 12;
        }
        if (this.useTriangleLayout) {
            return 12 / (nSelected - 1);
        }
        return 12 / nSelected;
    }

    taxesDico = {
        "1329AC": "Acompte de CVAE",
        "1329DEF": "Solde de CVAE",
        "2571SD": "Acompte d'IS",
        "2572SD": "Solde d'IS",
        "3310CA3": "TVA",
        "3514SD": "Acompte de TVA",
        "3517SCA12": "Solde de TVA",
    };

    taxesDepositsSchedule = {
        CVAE: ["06", "09"],
        IS: ["03", "06", "09", "12"],
        TVAQ: ["01", "04", "07", "10"],
        TVAS: ["07", "12"],
    };

    taxesDepositsDico = {
        "1329AC": "Acompte de CVAE",
        "2571SD": "Acompte d'IS",
        "3310CA3": "TVA",
        "3514SD": "Acompte de TVA",
        "3517SCA12": "Solde de TVA",
    };

    taxesBalancesDico = {
        "1329DEF": "Solde de CVAE",
        "2572SD": "Solde d'IS",
    };

    get company() {
        return this.props.item;
    }

    getColor(company, value, type) {
        if (this.taxType === "taxesDeposits") {
            return this.getTaxesDepositsColor(company, value, type);
        } else if (this.taxType === "taxesBalances") {
            return this.getTaxesBalancesColor(company, value, type);
        } else {
            if (this.isInTaxesBalances(value, type)) {
                return this.getTaxesBalancesColor(company, value, type);
            }
            return this.getTaxesDepositsColor(company, value, type);
        }
    }

    getTaxesBalancesColor(company, value, type) {
        if (value === "CVAE") {
            if (type.substring(5, 7) !== "05") {
                return this.white;
            }
            if (!company.accountingPeriods.length) {
                return this.white;
            }
            if (this.taxesMonitoringItem && this.taxesMonitoringItem[value]) {
                const declarations = this.taxesMonitoringItem[value];
                const theoreticalClosingDate = `${parseFloat(type.slice(0, 4)) - 1}-12`;
                if (declarations[theoreticalClosingDate]) {
                    const declaration = declarations[theoreticalClosingDate];
                    if (Object.keys(this.taxesBalancesDico).includes(declaration.cerfaNumber)) {
                        if (declaration.status === "SENT") {
                            return this.green;
                        }
                        if (declaration.status === "EDITION") {
                            return this.orange;
                        }
                    }
                }
            }
        }
        if (value === "IS") {
            if (company.taxSystemType !== "IS") {
                return this.white;
            }
            if (
                this.getCorporateTaxBalanceDueDate(company.accountingPeriods, new Date(type)) !==
                type
            ) {
                return this.white;
            }
            const theoreticalClosingDate =
                type.slice(-2) === "05"
                    ? moment(new Date(type)).subtract(5, "months").format("YYYY-MM")
                    : moment(new Date(type)).subtract(4, "months").format("YYYY-MM");
            if (this.taxesMonitoringItem && this.taxesMonitoringItem[value]) {
                const declarations = this.taxesMonitoringItem[value];
                if (declarations[theoreticalClosingDate]) {
                    const declaration = declarations[theoreticalClosingDate];
                    if (Object.keys(this.taxesBalancesDico).includes(declaration.cerfaNumber)) {
                        if (declaration.status === "SENT") {
                            return this.green;
                        }
                        if (declaration.status === "EDITION") {
                            return this.orange;
                        }
                    }
                }
            }
        }
        return this.red;
    }

    getTaxesDepositsColor(company, value, type) {
        if (
            (value === "CVAE" &&
                !this.taxesDepositsSchedule[value].includes(type.substring(5, 7))) ||
            (value === "IS" && company.taxSystemType !== "IS") ||
            (value === "IS" && !this.taxesDepositsSchedule[value].includes(type.substring(5, 7))) ||
            (value === "TVA" && company.vatSystem && isNotSubjectToVAT(company.vatSystem)) ||
            (value === "TVA" &&
                company.vatSystem &&
                company.vatSystem === "Quartely" &&
                !this.taxesDepositsSchedule["TVAQ"].includes(type.substring(5, 7))) ||
            (value === "TVA" &&
                company.vatSystem &&
                company.vatSystem === "Simplified" &&
                !this.taxesDepositsSchedule["TVAS"].includes(type.substring(5, 7)))
        ) {
            return this.white;
        }
        if (
            this.taxesMonitoringItem &&
            this.taxesMonitoringItem[value] &&
            this.taxesMonitoringItem[value][type]
        ) {
            if (this.taxesMonitoringItem[value][type].isFromMiscellaneousOperation) {
                return this.green;
            }
            if (
                this.taxesMonitoringItem[value][type].cerfaNumber &&
                this.taxesMonitoringItem[value][type].status
            ) {
                const declaration = this.taxesMonitoringItem[value][type];
                if (Object.keys(this.taxesDepositsDico).includes(declaration.cerfaNumber)) {
                    if (declaration.status === "SENT") {
                        return this.green;
                    }
                    if (declaration.status === "EDITION") {
                        return this.orange;
                    }
                }
            }
        }
        return this.red;
    }

    getCorporateTaxBalanceDueDate(
        accountingPeriods: { id: string; start: Date; end: Date }[],
        currentDate: Date,
    ): string {
        if (accountingPeriods) {
            const pastEndDates = accountingPeriods
                .map((period) => new Date(period.end))
                .filter((endDate) => endDate < currentDate)
                .sort((a, b) => a.getTime() - b.getTime());
            if (pastEndDates) {
                const mostRecentClosingDate = pastEndDates.pop();
                if (moment(mostRecentClosingDate).format("MM-DD") === "12-31") {
                    return moment(mostRecentClosingDate).add(5, "months").format("YYYY-MM");
                }
                return moment(mostRecentClosingDate).add(4, "months").format("YYYY-MM");
            }
        }
    }

    getDeclarationInfos(company, tax, date) {
        if (this.taxType === "taxesDeposits") {
            return this.getDepositDeclarationInfos(company, tax, date);
        } else if (this.taxType === "taxesBalances") {
            return this.getBalanceDeclarationInfos(company, tax, date);
        } else {
            if (this.isInTaxesBalances(tax, date)) {
                // console.log("getDeclarationInfos isInTaxesBalances", tax, date, this.isInTaxesBalances(tax, date), this.getBalanceDeclarationInfos(company, tax, date))
                return this.getBalanceDeclarationInfos(company, tax, date);
            }
            return this.getDepositDeclarationInfos(company, tax, date);
        }
    }

    getDepositDeclarationInfos(company, tax, date) {
        if (
            this.taxesMonitoringItem &&
            this.taxesMonitoringItem[tax] &&
            this.taxesMonitoringItem[tax][date]
        ) {
            // console.log("getDepositDeclarationInfos tax", tax, "date", date, this.taxesMonitoringItem[tax][date].cerfaNumber, `${this.taxesDepositsDico[this.taxesMonitoringItem[tax][date].cerfaNumber]} - ${moment(date).format("MM/YYYY")} - ${this.taxesMonitoringItem[tax][date].status === "SENT" ? "Validé" : "Édition"}`,)
            if (this.taxesMonitoringItem[tax][date].isFromMiscellaneousOperation) {
                return `OD de TVA - ${moment(date).format("MM/YYYY")}`;
            }
            return `${
                this.taxesDepositsDico[this.taxesMonitoringItem[tax][date].cerfaNumber]
            } - ${moment(date).format("MM/YYYY")} - ${
                this.taxesMonitoringItem[tax][date].status === "SENT" ? "Validé" : "Édition"
            }`;
        } else {
            if (tax === "IS") {
                if (this.taxesDepositsSchedule[tax].includes(date.substring(5, 7))) {
                    return `Déclaration d'acompte d'IS du 15/${moment(date).format(
                        "MM/YYYY",
                    )} manquante`;
                } else {
                    return `Pas de déclaration d'acompte d'IS attendue au mois de ${moment(
                        date,
                    ).format("MM/YYYY")}`;
                }
            } else if (tax === "TVA") {
                if (
                    (company.vatSystem === "Quartely" &&
                        this.taxesDepositsSchedule["TVAQ"].includes(date.substring(5, 7))) ||
                    (company.vatSystem === "Simplified" &&
                        this.taxesDepositsSchedule["TVAS"].includes(date.substring(5, 7))) ||
                    company.vatSystem === "Normal"
                ) {
                    if (company.vatDeclarationDay) {
                        return `Déclaration de TVA du ${company.vatDeclarationDay}/${moment(
                            date,
                        ).format("MM/YYYY")} manquante`;
                    } else {
                        return `Déclaration de TVA du mois de ${moment(date).format(
                            "MM/YYYY",
                        )} manquante`;
                    }
                } else {
                    return `Pas de déclaration de TVA attendue au mois de ${moment(date).format(
                        "MM/YYYY",
                    )}`;
                }
            } else if (tax === "CVAE") {
                if (this.taxesDepositsSchedule[tax].includes(date.substring(5, 7))) {
                    return `Déclaration d'acompte de CVAE du 15/${moment(date).format(
                        "MM/YYYY",
                    )} manquante`;
                } else {
                    return `Pas de déclaration d'acompte de CVAE attendue au mois de ${moment(
                        date,
                    ).format("MM/YYYY")}`;
                }
            }
        }
    }

    getBalanceDeclarationInfos(company, tax, date) {
        // same logic as getColor function
        if (tax === "CVAE") {
            if (date.substring(5, 7) !== "05") {
                return `Pas de déclaration de solde de CVAE attendue au mois de ${moment(
                    date,
                ).format("MM/YYYY")}`;
            }
            if (!company.accountingPeriods.length) {
                return `Pas de déclaration de solde de CVAE attendue au mois de ${moment(
                    date,
                ).format("MM/YYYY")}`;
            }
            if (this.taxesMonitoringItem && this.taxesMonitoringItem[tax]) {
                const declarations = this.taxesMonitoringItem[tax];
                const theoreticalClosingDate = `${parseFloat(date.slice(0, 4)) - 1}-12`;
                if (declarations[theoreticalClosingDate]) {
                    const declaration = declarations[theoreticalClosingDate];
                    if (Object.keys(this.taxesBalancesDico).includes(declaration.cerfaNumber)) {
                        if (declaration.status === "SENT") {
                            return `Solde CVAE - ${moment(date).format("MM/YYYY")} - Validé`;
                        }
                        if (declaration.status === "EDITION") {
                            return `Solde CVAE - ${moment(date).format("MM/YYYY")} - Édition`;
                        }
                    }
                }
            }
            return `Déclaration de solde de CVAE de ${moment(date).format("MM/YYYY")} manquante`;
        }
        if (tax === "IS") {
            if (company.taxSystemType !== "IS") {
                return `Pas de déclaration de solde d'IS attendue au mois de ${moment(date).format(
                    "MM/YYYY",
                )}`;
            }
            if (
                this.getCorporateTaxBalanceDueDate(company.accountingPeriods, new Date(date)) !==
                date
            ) {
                return `Pas de déclaration de solde d'IS attendue au mois de ${moment(date).format(
                    "MM/YYYY",
                )}`;
            }
            const theoreticalClosingDate =
                date.slice(-2) === "05"
                    ? moment(new Date(date)).subtract(5, "months").format("YYYY-MM")
                    : moment(new Date(date)).subtract(4, "months").format("YYYY-MM");
            if (this.taxesMonitoringItem && this.taxesMonitoringItem[tax]) {
                const declarations = this.taxesMonitoringItem[tax];
                if (declarations[theoreticalClosingDate]) {
                    const declaration = declarations[theoreticalClosingDate];
                    if (Object.keys(this.taxesBalancesDico).includes(declaration.cerfaNumber)) {
                        if (declaration.status === "SENT") {
                            return `Solde IS - ${moment(date).format("MM/YYYY")} - Validé`;
                        }
                        if (declaration.status === "EDITION") {
                            return `Solde IS - ${moment(date).format("MM/YYYY")} - Édition`;
                        }
                    }
                }
            }
            return `Déclaration de solde d'IS du 15/${moment(date).format("MM/YYYY")} manquante`;
        }
    }

    get red() {
        return colors.red.accent1;
    }

    get green() {
        return "green";
    }

    get blue() {
        return colors.blue.lighten1;
    }

    get orange() {
        return colors.orange.lighten1;
    }

    get white() {
        return colors.grey.lighten4;
    }

    get grey() {
        return colors.grey.lighten2;
    }

    taxesSelectedContain(tax) {
        return !!this.taxesSelected.filter((x) => x === tax).length;
    }

    async onNameClicked(item) {
        await this.openDashboard();
        this.$emit("name-clicked", item);
    }

    onAvatarClicked(company, type, date) {
        this.getClick(type, date);
        this.$emit("avatar-clicked", company, type, date);
        this.actionDialog = true;
    }

    async onDialogIgnoreClicked() {
        await this.createSet();
        this.$emit("dialog-ignore-clicked");
        this.actionDialog = false;
    }

    onDialogRedirectClicked() {
        this.redirectionAction();
        this.$emit("dialog-redirect-clicked");
    }

    getClick(type, date) {
        // this.actionSelectedCompany = company;
        this.actionType = type;
        this.actionDate = date;
        if (
            this.taxesMonitoringItem &&
            this.taxesMonitoringItem[type] &&
            this.taxesMonitoringItem[type][date] &&
            this.taxesMonitoringItem[type][date].id
        ) {
            if (this.taxesMonitoringItem[type][date].isFromMiscellaneousOperation) {
                this.redirectionAction(null, this.taxesMonitoringItem[type][date].id);
            } else {
                this.redirectionAction(this.taxesMonitoringItem[type][date].id, null);
            }
            return;
        }

        this.actionDialog = true;
    }

    async redirectionAction(declarationId: string = null, documentId: string = null) {
        const selectedCompany = this.company;
        await setCurrentCompany(this.$apollo, this.$store, selectedCompany, undefined, true);
        if (documentId) {
            this.$router.push({
                name: "document",
                params: { companyId: this.company.id, id: documentId },
            });
        } else if (declarationId) {
            this.$router.push({ name: "declaration", params: { decId: declarationId } });
        } else {
            this.$router.push({ name: "taxForms" });
        }
    }

    async createSet() {
        this.itemValue = await AccountingClientMonitoringServices.createSet(
            this.itemValue,
            this.actionType,
            this.actionDate,
            this.company.id,
        );
        this.actionDialog = false;
    }

    async openDashboard() {
        this.actionType = "DASHBOARD";
        this.actionDate = "";

        await setCurrentCompany(this.$apollo, this.$store, this.company, undefined, true);
        // this.$router.push({ name: "dashboard" });
        this.$router.push({ name: "companyStatusBoard" });
    }
}

export default toNative(AccountingClientMonitoringTaxesRow);
</script>
<style lang="css" scoped>
.avatarHover:hover {
    margin: 20px;
    border: 2px white solid;
}
</style>
